import React, { Component } from 'react';

class CuentaMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caretIcon: "down",
            isFeching: false,
            huboCambios: false
        };

        this.changeCaret = this.changeCaret.bind(this);
        this.getCuentaData = this.getCuentaData.bind(this);
        this.getTarjetaData = this.getTarjetaData.bind(this);
        this.getSaldosResumenesData = this.getSaldosResumenesData.bind(this);
        this.getIngresoAjustes = this.getIngresoAjustes.bind(this);
    }

    changeCaret() {
        this.setState({ caretIcon: this.state.caretIcon == "right" ? "down" : "right" });
    }

    getCuentaData() {
        this.setState({
            isFeching: true,
            huboCambios: true
        },
            this.props.seleccionarOpcionRama(1, this.props.cuenta.Id, this.props.getCuentaData));
    }

    getTarjetaData() {
        this.setState({
            isFeching: true,
            huboCambios: true
        }, this.props.seleccionarOpcionRama(2, this.props.cuenta.Id, this.props.getTarjetaData));
    }

    getSaldosResumenesData() {
        this.setState({
            //isFeching: true,
            huboCambios: true
        }, this.props.seleccionarOpcionRama(3, this.props.cuenta.Id, this.props.getSaldosResumenesData));
    }

    getIngresoAjustes() {
        this.setState({
            //isFeching: true,
            huboCambios: true
        }, this.props.seleccionarOpcionRama(4, this.props.cuenta.Id, this.props.getIngresoAjustes));
    }

    componentWillReceiveProps(nextProps) {
        /*No importa cual fuese el resultado siempre seteo el valor del spinner en false*/
        this.state.isFeching = false;
    }

    render() {
        const { opcionSeleccionadaId, cuenta, cuentaDatos, primeraCuenta, entidadTipo } = this.props;
        const existeCuentaDatos = (cuentaDatos != undefined);
        const cuentaSeleccionada = ((opcionSeleccionadaId == 1 || (entidadTipo == 1 && opcionSeleccionadaId != 3)) && (existeCuentaDatos ? (cuenta.Id == cuentaDatos.Id) : true));
        const saldosSeleccionado = ((opcionSeleccionadaId == 3 && entidadTipo == 1) && (existeCuentaDatos ? (cuenta.Id == cuentaDatos.Id) : true));
        const tarjetaSeleccionada = ((opcionSeleccionadaId == 2 || entidadTipo == 2) && (existeCuentaDatos ? (cuenta.Id == cuentaDatos.Id) : true));

        const separator = "left-separator-xs top-separator-xxs";
        const topSeparator = " top-separator-xxs";
        const tituloSaldosResumenes = "Saldos y Res" + String.fromCharCode(250) + "menes";
        const tituloDG = "Datos Generales";
        const tituloAjustes = "Ingreso de Ajustes";

        return (
            <div className="row">
                {this.state.isFeching == true &&
                    < div className="loading"> Loading &#8230;</div>}

                <div className="col-xs-12">
                    <a className="btn-link btn-link-labeled-secondary"
                        onClick={() => this.changeCaret()}
                        data-toggle="collapse"
                        data-target={"#Cuenta_" + this.props.cuenta.Id}>
                        <i className={"fa fa-caret-" + this.state.caretIcon} aria-hidden="true"></i>
                        &nbsp;
                        {this.props.cuenta.Descripcion}
                    </a>
                    <div id={"Cuenta_" + this.props.cuenta.Id} className={"collapse " + selected ? "in" : ""}>
                        <ul className="ul-no-decorate container-fluid top-separator-xs">
                            <li className={cuentaSeleccionada ? "option-selected " + topSeparator : topSeparator}>
                                {cuentaSeleccionada ?
                                    (<a className={"btn-link btn-link-labeled-primary " + separator}>{tituloDG}</a>)

                                    : ((this.props.cuenta.CuentaTarjetaEstadoId != 1) ?
                                        <a className={"btn-link btn-link-labeled-secondary " + separator} onClick={this.getCuentaData}>Datos generales</a> :
                                        <a className={"btn-link btn-link-labeled-primary " + separator}>{tituloDG}</a>)}
                            </li>
                            <li className={saldosSeleccionado ? "option-selected " + topSeparator : topSeparator}>
                                {saldosSeleccionado ?
                                    (<a className={"btn-link btn-link-labeled-primary " + separator}>{tituloSaldosResumenes}</a>)
                                    :
                                    <a className={"btn-link btn-link-labeled-secondary " + separator} onClick={this.getSaldosResumenesData}>{tituloSaldosResumenes}</a>
                                }
                            </li>
                            <li className={ajustesSeleccionada ? "option-selected " + topSeparator : topSeparator}>
                                {ajustesSeleccionada ?
                                    (<a className={"btn-link btn-link-labeled-primary " + separator}>{tituloAjustes}</a>)
                                    :
                                    <a className={"btn-link btn-link-labeled-secondary " + separator} onClick={this.getIngresoAjustes}>{tituloAjustes}</a>
                                }
                            </li>
                            <li className={tarjetaSeleccionada ? "option-selected " + topSeparator : topSeparator}>
                                {tarjetaSeleccionada ?
                                    (<a className={"btn-link btn-link-labeled-primary " + separator}>Tarjetas</a>)
                                    :
                                    ((this.props.cuenta.CuentaTarjetaEstadoId != 1) ?
                                        <a className={"btn-link btn-link-labeled-secondary " + separator} onClick={this.getTarjetaData}>Tarjetas&nbsp;</a> :
                                        <a className={"btn-link btn-link-labeled-primary " + separator}>Tarjetas&nbsp;</a>)
                                }
                            </li>
                        </ul>
                    </div>
                </div>
            </div >
        );
    }
}

export default CuentaMenu;